export default __webpack_public_path__ + "4a8e004d4b519a23daad23572de6b184.png";